import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppState } from '@services/core/app-state';

interface DynamicEnvironment {
  URL_MONITOR: string;
  URL_MonitorConversaciones: string;
  URL_MonitorConversacionesDetalle: string;
  URL_MULTIAGENDA: string;
  URL_MULTICANAL_API: string;
  [key: string]: string;
}

interface ParametroConfig {
  proceso: string;
  variable: string;
  key: keyof DynamicEnvironment;
  default: string;
}

@Injectable({
  providedIn: 'root'
})
export class EnvironmentDynamicServiceService {

  private readonly http = inject(HttpClient);
  private readonly app = inject(AppState);

  private readonly urlParametroSistema = 'https://www.sicopweb.com/Api/Bot/getParametroDeSistema';

  private get procesos(): ParametroConfig[] {
    const host = this.app.ENV.MTY_SICOP;
    return [
      { proceso: 'URL', variable: 'PATHMonitor', key: 'URL_MONITOR', default: host },
      { proceso: 'URL', variable: 'PATHMonitorConversaciones', key: 'URL_MonitorConversaciones', default: host },
      { proceso: 'URL', variable: 'PATHMonitorConversacionesDetalle', key: 'URL_MonitorConversacionesDetalle', default: host },
      { proceso: 'URL', variable: 'PATHMultiagenda', key: 'URL_MULTIAGENDA', default: `${host}/ApisSeekopServices/api` },
      // Base URL para el monitor multicanal; si viene vacío se usa URL_MonitorConversaciones como fallback
      { proceso: 'Multicanal', variable: 'UrlApi', key: 'URL_MULTICANAL_API', default: '' },
    ];
  }

  private urls: DynamicEnvironment = {
    URL_MONITOR: '',
    URL_MonitorConversaciones: '',
    URL_MonitorConversacionesDetalle: '',
    URL_MULTIAGENDA: '',
    URL_MULTICANAL_API: ''
  };

  private loaded = false;

  constructor() {
    for (const p of this.procesos) {
      this.urls[p.key] = p.default;
    }
  }

  async loadEnvironment(idDistribuidor: string): Promise<void> {
    for (const p of this.procesos) {
      try {
        const params = new HttpParams()
          .set('idDistribuidor', idDistribuidor)
          .set('proceso', p.proceso)
          .set('variable', p.variable);

        const resp = await firstValueFrom(
          this.http.get<any>(this.urlParametroSistema, { params })
        );
        const valor = typeof resp?.valor === 'string' ? resp.valor.trim() : '';
        this.urls[p.key] = valor || p.default;

        if (!valor) {
          console.warn(`[EnvDynamic] ${p.variable} sin valor, usando default:`, p.default);
        }
      } catch (err) {
        this.urls[p.key] = p.default;
        console.warn(`[EnvDynamic] Error cargando ${p.variable}, usando default:`, p.default, err);
      }
    }

    this.loaded = true;
    console.log('🌍 Configuración dinámica cargada:', this.urls);
  }

  get(key: keyof DynamicEnvironment): string {
    return this.urls[key];
  }

  isLoaded(): boolean {
    return this.loaded;
  }
}
